module.exports = __webpack_public_path__ + "static/media/other_pages_desktop.5c35269d.jpg";